import script from "./NumberText.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberText.vue?vue&type=script&setup=true&lang=ts"

import "./NumberText.vue?vue&type=style&index=0&id=373b20a2&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-373b20a2"]])

export default __exports__